import { useEffect, useRef } from 'react'
import image1 from './images/1.jpg'
import image2 from './images/2.jpg'
import image3 from './images/3.jpg'
import './carousel.css'

const AUTOPLAY_INTERVAL = 5000

export const ReasonSection: React.FC = () => {
  const carousel = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    const element = carousel.current

    if (!element) return

    const next = () => {
      const width = element.clientWidth
      const maxScrollLeft = element.scrollWidth - width
      const left = element.scrollLeft >= maxScrollLeft - 1 ? 0 : element.scrollLeft + width

      element.scrollTo({ left, behavior: 'smooth' })
    }

    let timer = setInterval(next, AUTOPLAY_INTERVAL)

    // 手でスワイプした直後に勝手に動かないよう、操作されたら数え直す
    const reset = () => {
      clearInterval(timer)
      timer = setInterval(next, AUTOPLAY_INTERVAL)
    }

    element.addEventListener('pointerdown', reset)
    element.addEventListener('wheel', reset, { passive: true })

    return () => {
      clearInterval(timer)
      element.removeEventListener('pointerdown', reset)
      element.removeEventListener('wheel', reset)
    }
  }, [])

  return (
    <section className="bg-white py-14 px-6">
      <div className="max-w-md mx-auto flex flex-col gap-6 items-center relative">
        <div className="flex flex-col gap-4 items-center">
          <h2 className="text-[24px] font-bold text-black text-center leading-[1.4]">
            最高にかわいいバラを
            <br />
            お届けできる理由
          </h2>
          <p className="text-[14px] leading-[1.6] text-black">
            定期便を運営するのは、毎日数万本の花を出荷するオンラインのお花屋さん「FLOWER（フラワー）」。バラについても、年間を通して膨大な数を仕入れています。その積み重ねがあるからこそ、多くの生産者さんや市場から個性豊かなバラをみなさまの元にお届けすることができます。
          </p>
        </div>
        <div ref={carousel} className="rose-reason-carousel w-full">
          <img src={image1} alt="" />
          <img src={image2} alt="" />
          <img src={image3} alt="" />
        </div>
      </div>
    </section>
  )
}
